import React, { Component } from 'react'
import './App.css'
import './Theme.css'
import './FeesPage.css'
import './Checkout.css' // still needed: the booking fee modal is styled here
import './CheckoutPage.css'
import { Link } from 'react-router-dom'
import Axios from 'axios'
import { BsPlus, BsDash } from 'react-icons/bs'
import { BiSolidInfoCircle } from 'react-icons/bi'
import ClipLoader from 'react-spinners/ClipLoader'
import calculateBookingFee from './components/calculateBookingFee'
import BookingFeeBreakdownModal from './modals/BookingFeesModa'
import Header from './layouts/Header'
import { API_URL } from './config'

const customer_id = localStorage.getItem('customerid')

const MAX_TOTAL = 15 // maximum tickets per order

/* ---------- helpers ---------- */

const prettyDate = (value) => {
  if (!value) return ''
  const d = new Date(`${value}T00:00:00`)
  if (isNaN(d.getTime())) return value
  return d.toLocaleDateString('en-ZA', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}

const fmt = (n) =>
  'R' +
  Number(n)
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
const cents = (n) => Math.round(Number(n) * 100) / 100
const num = (v) => {
  const n = Number(v)
  return Number.isFinite(n) ? n : 0
}
// Missing/unknown stock counts as "no limit" (the 15-per-order cap still applies).
const stock = (v) => {
  const n = parseInt(v, 10)
  return Number.isNaN(n) ? Infinity : Math.max(n, 0)
}

const tierOf = (cat) => {
  if (cat == 'VVIP') return { label: 'VVIP', cls: 'vvip' }
  if (cat == 'VIP') return { label: 'VIP', cls: 'vip' }
  return { label: 'General', cls: 'general' }
}

// All ticket types for this order. The event page sends them in router state and
// in the `tickets` URL param; older links fall back to the single-ticket fields.
const readTickets = (props) => {
  const query = new URLSearchParams(props.location.search)
  let list = props.location.state && props.location.state.tickets
  if (!Array.isArray(list) || list.length === 0) {
    try {
      list = JSON.parse(query.get('tickets'))
    } catch (e) {
      list = null
    }
  }
  if (!Array.isArray(list) || list.length === 0) {
    list = [
      {
        ticketid: query.get('ticketid'),
        ticketref: query.get('ticketref'),
        category: query.get('category'),
        price: query.get('price'),
        kids_price: query.get('kids_price'),
        avail_tickets: query.get('avail_tickets'),
        kids_tickets: query.get('kids_tickets'),
      },
    ]
  }
  return list.map((t) => ({
    ticketid: t.ticketid,
    ticketref: t.ticketref,
    category: t.category,
    tier: tierOf(t.category),
    price: num(t.price),
    kidsPrice: num(t.kids_price),
    availAdults: stock(t.avail_tickets),
    availKids: stock(t.kids_tickets),
  }))
}

// One purchasable row per ticket type and group (adults / kids / free entry).
const buildRows = (tickets) => {
  const rows = []
  tickets.forEach((t) => {
    if (t.price > 0 || t.kidsPrice <= 0) {
      rows.push({
        key: `${t.ticketid}:adults`,
        ticket: t,
        group: 'adults',
        label: t.price > 0 ? 'Adults' : 'Entry',
        price: t.price,
        stock: t.availAdults,
      })
    }
    if (t.kidsPrice > 0) {
      rows.push({
        key: `${t.ticketid}:kids`,
        ticket: t,
        group: 'kids',
        label: 'Kids',
        price: t.kidsPrice,
        stock: t.availKids,
      })
    }
  })
  return rows
}

const Icon = ({ name, size = 20 }) => {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  }
  switch (name) {
    case 'calendar':
      return (
        <svg {...common}>
          <rect x="3" y="4" width="18" height="18" rx="3" />
          <path d="M16 2v4M8 2v4M3 10h18" />
        </svg>
      )
    case 'clock':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
      )
    case 'pin':
      return (
        <svg {...common}>
          <path d="M12 22s7-6.2 7-12a7 7 0 1 0-14 0c0 5.8 7 12 7 12z" />
          <circle cx="12" cy="10" r="2.5" />
        </svg>
      )
    case 'back':
      return (
        <svg {...common}>
          <path d="M15 18l-6-6 6-6" />
        </svg>
      )
    case 'lock':
      return (
        <svg {...common}>
          <rect x="4" y="11" width="16" height="10" rx="2" />
          <path d="M8 11V8a4 4 0 0 1 8 0v3" />
        </svg>
      )
    case 'ticket':
      return (
        <svg {...common}>
          <path d="M3 9a2 2 0 0 0 0 6v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3a2 2 0 0 1 0-6V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1z" />
          <path d="M14 5v14" strokeDasharray="2 3" />
        </svg>
      )
    default:
      return null
  }
}

class Finalize extends Component {
  constructor(props) {
    super(props)
    const query = new URLSearchParams(this.props.location.search)

    this.summaryRef = React.createRef()
    this.tickets = readTickets(props)
    this.rows = buildRows(this.tickets)

    // Start with one ticket of the type the buyer clicked through with (the cheapest).
    const startId = query.get('ticketid')
    const open = this.rows.filter((r) => r.stock > 0)
    const start = open.find((r) => String(r.ticket.ticketid) === String(startId)) || open[0]

    this.state = {
      cart: start ? { [start.key]: 1 } : {},
      isChecked: false,
      paying: null,
      maxMessage: '',
      ticketnumber: Math.random().toString(36).substr(2, 7).toUpperCase(),
      key: Math.random().toString(36).substr(1, 100).toUpperCase(),
      customer_email_address: '',
      customer_name: '',
      customer_phone: '',
      customerId: null,
      showModal: false,
      description: '',
      venue: '',
      eventName: '',
      eventDate: '',
      startTime: '',
      endTime: '',
      poster: '',
      businessId: 0,
      eventId: 0,
      campaignStatus: 'stop',
      refundAllowed: false,
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0) // start at the top, not wherever the event page was scrolled to
    const query = new URLSearchParams(this.props.location.search)
    const { eventid } = this.props.match.params
    document.title = 'Karamale | ' + query.get('eventname')
    localStorage.setItem('group', 'adults')

    if (
      !(
        query.has('eventid') &&
        query.has('eventname') &&
        query.has('eventDate') &&
        query.has('fulldate') &&
        query.has('posterUri') &&
        query.has('accountid') &&
        query.has('accounttype') &&
        query.has('venue') &&
        query.has('description') &&
        query.has('businessid') &&
        query.has('poster') &&
        query.has('eventday') &&
        query.has('starttime') &&
        query.has('endtime') &&
        query.has('previousPage') &&
        query.has('campaignStatus') &&
        query.has('ticketid') &&
        query.has('ticketref') &&
        query.has('command') &&
        query.has('eventtype')
      )
    ) {
      this.props.history.goBack()
    }

    // get event details
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=FETCH-EVENT-DETAILS&eventid=${eventid}`,
      {
        withCredentials: true,
      },
    ).then((response) => {
      this.setState({
        description: response.data.description,
        venue: response.data.venue,
        eventName: response.data.eventName,
        eventDate: response.data.eventDate,
        startTime: response.data.startTime,
        poster: response.data.poster,
        businessId: response.data.businessId,
        endTime: response.data.endTime,
        campaignStatus: response.data.campaignStatus,
        refundAllowed: response.data.refundAllowed,
      })
    })

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=LOG-EVENT-CLICKS&event_id=${eventid}`,
      {
        withCredentials: true,
      },
    )
      .then(() => {})
      .catch((error) => {
        console.log(error)
      })

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=CUSTOMERDETAILS`, {
      withCredentials: true,
    })
      .then((response) => {
        this.setState({
          customer_email_address: response.data.email,
          customer_name: response.data.customername,
          customer_phone: response.data.phone,
          customerId: response.data.customer_id,
        })
      })
      .catch((err) => console.log(err))
  }

  checkHandleClicked = () => this.setState((prev) => ({ isChecked: !prev.isChecked }))

  scrollToSummary = () => {
    if (this.summaryRef.current) {
      this.summaryRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  /* ---------- cart ---------- */

  changeQty = (key, delta) => {
    this.setState((prev) => {
      const row = this.rows.find((r) => r.key === key)
      if (!row) return null
      const cur = prev.cart[key] || 0
      const totalQty = Object.values(prev.cart).reduce((a, b) => a + b, 0)
      let next = cur + delta
      let msg = ''

      if (delta > 0) {
        if (cur >= row.stock) {
          next = cur
          if (row.stock === 0) {
            msg = `${row.ticket.tier.label} ${row.label.toLowerCase()} tickets are sold out`
          } else {
            msg = `There ${row.stock === 1 ? 'is' : 'are'} only ${row.stock} ${
              row.ticket.tier.label
            } ${row.stock === 1 ? 'ticket' : 'tickets'} left`
          }
        } else if (totalQty >= MAX_TOTAL) {
          next = cur
          msg = `You've reached the maximum of ${MAX_TOTAL} tickets per order`
        }
      }

      const cart = { ...prev.cart }
      if (next <= 0) delete cart[key]
      else cart[key] = next
      return { cart, maxMessage: msg }
    })
  }

  // Lines, totals and booking fees for the current cart.
  summary = () => {
    const lines = this.rows
      .filter((r) => this.state.cart[r.key] > 0)
      .map((r) => ({ ...r, qty: this.state.cart[r.key] }))

    const totalQty = lines.reduce((a, l) => a + l.qty, 0)
    const subtotal = cents(lines.reduce((a, l) => a + l.price * l.qty, 0))

    const fees = lines.map((l) => calculateBookingFee(l.price, l.qty))
    const sum = (field) => fees.reduce((a, f) => a + Number(f[field] || 0), 0)
    const bookingFee = cents(sum('totalBookingFees'))
    const total = cents(subtotal + bookingFee)

    let detail = null
    if (fees.length === 1) {
      detail = { ticketPrice: lines[0].price, ...fees[0] }
    } else if (fees.length > 1) {
      detail = {
        ticketPrice: subtotal,
        karamaleRate: fees[0].karamaleRate,
        gatewayRate: fees[0].gatewayRate,
        bookingFeeAdmission: sum('bookingFeeAdmission'),
        gatewayFlatFee: sum('gatewayFlatFee'),
        estimatedGatewayFee: sum('estimatedGatewayFee'),
        finalEstimatedGatewayFee: sum('finalEstimatedGatewayFee'),
      }
    }

    return { lines, totalQty, subtotal, bookingFee, total, detail }
  }

  /* ---------- payment ---------- */

  pay = (source) => {
    const { lines, totalQty, total } = this.summary()
    if (lines.length === 0) return

    const query = new URLSearchParams(this.props.location.search)
    const eventid = query.get('eventid')
    const businessid = query.get('businessid')
    const eventname = query.get('eventname')
    const primary = lines[0]
    const ticketid = primary.ticket.ticketid
    const email = this.state.customer_email_address
    const ticketnumber = this.state.ticketnumber

    // Every line of the order, so mixed ticket types can be issued from one payment.
    const items = lines.map((l) => ({
      ticketid: l.ticket.ticketid,
      ticketref: l.ticket.ticketref,
      category: l.ticket.tier.label,
      group: l.group,
      price: l.price,
      quantity: l.qty,
    }))

    localStorage.setItem('group', primary.group)
    this.setState({ paying: source })

    const nameParts = (this.state.customer_name || '').split(/\s+/)
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

    const formData = new FormData()
    formData.append('item_name', eventname)
    formData.append('amount', total.toFixed(2))
    formData.append('email', email)
    formData.append('cell_number', this.state.customer_phone)
    formData.append('name_first', nameParts[0])
    formData.append('name_last', nameParts[1])
    formData.append('admission', totalQty)
    formData.append('adults_price', primary.ticket.price)
    formData.append('kids_price', primary.ticket.kidsPrice)
    formData.append('category', primary.ticket.tier.label)
    formData.append('ticketid', ticketid)
    formData.append('ticketnumber', ticketnumber)
    formData.append('eventid', eventid)
    formData.append('payment_method', 'eft')
    formData.append('businessid', businessid)
    formData.append('type', 'purchase_ticket')
    formData.append('group', primary.group)
    formData.append('items', JSON.stringify(items))
    formData.append('multi_ticket', items.length > 1 ? 'yes' : 'no')
    formData.append('is_mobile', isMobile ? 'yes' : 'no')
    formData.append('customer_id', this.state.customerId)
    formData.append('user_agent', navigator.userAgent)
    formData.append('language', navigator.language)
    formData.append('screen_resolution', window.screen.width + 'x' + window.screen.height)
    formData.append('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone)
    formData.append('platform', navigator.platform)
    formData.append('cpu_cores', navigator.hardwareConcurrency || 0)
    formData.append('device_memory', navigator.deviceMemory || 0)
    formData.append('touch_points', navigator.maxTouchPoints || 0)

    const postUrl =
      source === 'ozow'
        ? `${API_URL}/apps/kscanner/ozowCredentials.php`
        : `${API_URL}/apps/kscanner/payfast_credentials.php`

    fetch(postUrl, { method: 'POST', body: formData })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 'failed') {
          alert(data.message)
          this.setState({ paying: null })
          return
        }
        if (data.status === 'review') {
          this.props.history.push({
            pathname: '/verification-process',
            state: {
              m_payment_id: data.m_payment_id,
              reponseMessage: data.message,
              customer_id: data.customer_id,
            },
          })
          return
        }

        if (isMobile || source === 'ozow') {
          const form = document.createElement('form')
          form.method = 'POST'
          form.action = source === 'ozow' ? data.ozowUrl : 'https://www.payfast.co.za/eng/process'

          for (const [key, value] of Object.entries(data)) {
            const input = document.createElement('input')
            input.type = 'hidden'
            input.name = key
            input.value = value
            form.appendChild(input)
          }

          document.body.appendChild(form)
          form.submit()
        } else if (data.uuid) {
          const first = (this.state.customer_name || '').split(' ')[0]
          const last = (this.state.customer_name || '').split(' ')[1]
          window.payfast_do_onsite_payment({
            uuid: data.uuid,
            return_url: `${API_URL}/success`,
            cancel_url:
              `${API_URL}/cancelled?customer_id=${customer_id}` +
              `&ticket_number=${ticketnumber}&ticket_id=${ticketid}` +
              `&event_id=${eventid}&business_id=${businessid}` +
              `&name_first=${encodeURIComponent(first || '')}` +
              `&name_last=${encodeURIComponent(last || '')}` +
              `&email=${encodeURIComponent(email || '')}` +
              `&item_name=${encodeURIComponent(eventname || '')}&admission=${totalQty}` +
              `&m_payment_id=${encodeURIComponent(data.m_payment_id || '')}`,
            // `&item_name=${encodeURIComponent(eventname || '')}&admission=${totalQty}`,
          })
        } else {
          alert('Failed to initiate payment.')
        }

        // Same as before: the agreement has to be ticked again for another attempt.
        this.setState({ isChecked: false, paying: null })
      })
      .catch(() => {
        alert('Something went wrong while starting the payment. Please try again.')
        this.setState({ paying: null })
      })
  }

  /* ---------- render ---------- */

  renderRow = (row) => {
    const qty = this.state.cart[row.key] || 0
    const orderQty = Object.values(this.state.cart).reduce((a, b) => a + b, 0)
    const soldOut = row.stock === 0
    // Each ticket type and group has its own stock; the order as a whole is capped too.
    const atStock = !soldOut && Number.isFinite(row.stock) && qty >= row.stock
    const atCap = orderQty >= MAX_TOTAL
    const few = !soldOut && !atStock && row.stock <= 10 && Number.isFinite(row.stock)
    return (
      <div key={row.key} className={`co-row ${qty > 0 ? 'is-on' : ''} ${soldOut ? 'is-sold' : ''}`}>
        <div className="co-row__info">
          <b>{row.label}</b>
          <span className="co-row__price">{row.price > 0 ? fmt(row.price) : 'Free'}</span>
          {soldOut && <span className="co-flag co-flag--sold">Sold out</span>}
          {few && <span className="co-flag co-flag--few">{row.stock} left</span>}
          {atStock && <span className="co-flag co-flag--max">Max available</span>}
        </div>
        <div className="co-qty">
          <button
            type="button"
            className="co-qty__btn"
            onClick={() => this.changeQty(row.key, -1)}
            disabled={qty === 0}
            aria-label={`Remove one ${row.ticket.tier.label} ${row.label} ticket`}
          >
            <BsDash />
          </button>
          <span className="co-qty__n" aria-live="polite">
            {qty}
          </span>
          <button
            type="button"
            className="co-qty__btn"
            onClick={() => this.changeQty(row.key, 1)}
            disabled={soldOut || atStock || atCap}
            aria-label={`Add one ${row.ticket.tier.label} ${row.label} ticket`}
          >
            <BsPlus />
          </button>
        </div>
      </div>
    )
  }

  render() {
    const query = new URLSearchParams(this.props.location.search)
    const eventname = query.get('eventname')
    const poster = query.get('poster')
    const eventDate = query.get('eventDate')
    const eventday = query.get('eventday')
    const starttime = query.get('starttime')
    const endtime = query.get('endtime')
    const venue = query.get('venue')

    const { lines, totalQty, subtotal, bookingFee, total, detail } = this.summary()

    const loggedIn = localStorage.getItem('customername') !== null
    const isStage = API_URL.toLowerCase() === 'https://stage.karamale.com'
    const shownTitle = this.state.eventName || eventname
    const shownDate = prettyDate(this.state.eventDate || eventDate) || eventday
    const shownStart = this.state.startTime || starttime
    const shownEnd = this.state.endTime || endtime
    const shownVenue = this.state.venue || venue
    const payDisabled = !this.state.isChecked || totalQty === 0 || !!this.state.paying

    return (
      <div className="fp-page co-page">
        <Header />

        <div className="co-wrap">
          <div className="co-top">
            <button type="button" className="co-back" onClick={() => this.props.history.goBack()}>
              <Icon name="back" size={18} /> Back
            </button>
            <h1 className="co-top__title">Checkout</h1>
            <span className="co-secure">
              <Icon name="lock" size={15} /> Secure payment
            </span>
          </div>

          <div className="co-body">
            {/* ---------- left: event + ticket selection ---------- */}
            <div className="co-main">
              <section className="co-card co-event">
                <div className="co-event__poster">
                  {poster ? (
                    <img src={poster} alt={shownTitle} />
                  ) : (
                    <Icon name="ticket" size={34} />
                  )}
                </div>
                <div className="co-event__info">
                  <h2 className="co-event__title">{shownTitle}</h2>
                  <ul className="co-facts">
                    <li>
                      <Icon name="calendar" size={16} />
                      <span>{shownDate}</span>
                    </li>
                    <li>
                      <Icon name="clock" size={16} />
                      <span>
                        {shownStart}
                        {shownEnd ? ` – ${shownEnd}` : ''}
                      </span>
                    </li>
                    <li>
                      <Icon name="pin" size={16} />
                      <span>{shownVenue}</span>
                    </li>
                  </ul>
                </div>
              </section>

              <section className="co-card">
                <div className="co-card__head">
                  <div>
                    <h2 className="co-h2">Choose your tickets</h2>
                    <p className="co-sub">
                      Mix ticket types in one order. Each ticket is issued separately.
                    </p>
                  </div>
                  <span className="co-count">
                    {totalQty} / {MAX_TOTAL}
                  </span>
                </div>

                <div className="co-types">
                  {this.tickets.map((t) => (
                    <div className="co-type" key={t.ticketid}>
                      <div className="co-type__head">
                        <span className={`co-tier co-tier--${t.tier.cls}`}>{t.tier.label}</span>
                      </div>
                      {this.rows.filter((r) => r.ticket === t).map(this.renderRow)}
                    </div>
                  ))}
                </div>

                <p className="co-max" role="status">
                  {totalQty >= MAX_TOTAL
                    ? `You've reached the maximum of ${MAX_TOTAL} tickets per order`
                    : this.state.maxMessage}
                </p>
              </section>

              {this.state.description ? (
                <section className="co-card">
                  <h2 className="co-h2">About this event</h2>
                  <div
                    className="co-prose"
                    dangerouslySetInnerHTML={{ __html: this.state.description }}
                  />
                </section>
              ) : null}

              {this.state.venue ? (
                <section className="co-card">
                  <div className="co-card__head">
                    <h2 className="co-h2">Venue</h2>
                    <a
                      className="co-outline"
                      href={
                        'https://www.google.com/maps/search/?api=1&query=' +
                        encodeURIComponent(this.state.venue)
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Icon name="pin" size={15} /> Open in Maps
                    </a>
                  </div>
                  <p className="co-venue">{this.state.venue}</p>
                  <div className="co-map">
                    <iframe
                      title="Event location"
                      loading="lazy"
                      src={
                        'https://maps.google.com/maps?t=&z=13&ie=UTF8&iwloc=&output=embed&q=' +
                        encodeURIComponent(this.state.venue)
                      }
                    ></iframe>
                  </div>
                </section>
              ) : null}
            </div>

            {/* ---------- right: order summary ---------- */}
            <aside className="co-panel" ref={this.summaryRef}>
              <div className="co-panel__card">
                <div className="co-panel__head">
                  <h2>Your order</h2>
                  <span>
                    {totalQty} {totalQty === 1 ? 'ticket' : 'tickets'}
                  </span>
                </div>

                {!loggedIn ? (
                  <div className="co-auth">
                    <p>Log in or register to buy tickets.</p>
                    <div className="co-auth__row">
                      <Link to="/login" className="co-btn co-btn--primary">
                        Log in
                      </Link>
                      <Link to="/customer-registration" className="co-btn co-btn--outline">
                        Register
                      </Link>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="co-section">
                      {lines.length === 0 ? (
                        <p className="co-empty">Select at least one ticket to continue.</p>
                      ) : (
                        <ul className="co-lines">
                          {lines.map((l) => (
                            <li key={l.key}>
                              <span className={`co-dot co-dot--${l.ticket.tier.cls}`} />
                              <span className="co-lines__name">
                                {l.qty} × {l.ticket.tier.label} {l.label}
                              </span>
                              <b>{fmt(l.price * l.qty)}</b>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>

                    <div className="co-section">
                      <div className="co-details__head">
                        <span className="co-label">Your details</span>
                        <Link to="/profile" className="co-link">
                          Change details
                        </Link>
                      </div>
                      <div className="co-details">
                        <div>
                          <span>Name</span>
                          <b>{this.state.customer_name}</b>
                        </div>
                        <div>
                          <span>Email</span>
                          <b>{this.state.customer_email_address}</b>
                        </div>
                        <div>
                          <span>Phone</span>
                          <b>{this.state.customer_phone}</b>
                        </div>
                      </div>
                    </div>

                    <div className="co-section">
                      <div className="co-sum">
                        <div className="co-sum__row">
                          <span>Subtotal</span>
                          <span>{fmt(subtotal)}</span>
                        </div>
                        <div className="co-sum__row">
                          <button
                            type="button"
                            className="co-infobtn"
                            onClick={() => this.setState({ showModal: true })}
                            disabled={!detail}
                          >
                            Booking fee <BiSolidInfoCircle size={15} />
                          </button>
                          <span>{fmt(bookingFee)}</span>
                        </div>
                        <div className="co-sum__row co-sum__row--total">
                          <span>Total</span>
                          <b>{fmt(total)}</b>
                        </div>
                      </div>
                    </div>

                    <div className="co-agree">
                      <input
                        type="checkbox"
                        checked={this.state.isChecked}
                        name="agreement"
                        onChange={this.checkHandleClicked}
                        id="agreement"
                      />
                      <label htmlFor="agreement">
                        I agree to the{' '}
                        <Link to={'/terms-conditions'} target="_blank" className="co-link">
                          Terms
                        </Link>{' '}
                        and{' '}
                        <Link to={'/ticketing-policy'} target="_blank" className="co-link">
                          Ticketing policy
                        </Link>
                        .
                      </label>
                    </div>

                    {isStage ? (
                      <div className="co-note co-note--warn">
                        You are currently in the staging environment. No real payments will be
                        processed.
                      </div>
                    ) : null}

                    {this.state.refundAllowed == 0 ? (
                      <div className="co-note co-note--warn" role="alert">
                        Tickets for this event are non-refundable.
                      </div>
                    ) : null}

                    {!isStage && (
                      <div className="co-pay-wrap">
                        <button
                          type="button"
                          disabled={payDisabled}
                          className="co-pay co-pay--ozow"
                          onClick={() => this.pay('ozow')}
                        >
                          {this.state.paying === 'ozow' ? (
                            <ClipLoader size={20} color="grey" />
                          ) : (
                            'Secure Payment (Ozow)'
                          )}
                        </button>
                        <button
                          type="button"
                          disabled={payDisabled}
                          className="co-pay co-pay--payfast"
                          onClick={() => this.pay('payfast')}
                        >
                          {this.state.paying === 'payfast' ? (
                            <ClipLoader size={20} color="grey" />
                          ) : (
                            'Secure Payment (PayFast)'
                          )}
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>
            </aside>
          </div>
        </div>

        {/* ---------- mobile total bar ---------- */}
        {loggedIn && (
          <div className="co-bar">
            <div className="co-bar__price">
              <small>
                Total · {totalQty} {totalQty === 1 ? 'ticket' : 'tickets'}
              </small>
              <b>{fmt(total)}</b>
            </div>
            <button
              type="button"
              className="co-btn co-btn--primary"
              onClick={this.scrollToSummary}
              disabled={totalQty === 0}
            >
              Review &amp; pay
            </button>
          </div>
        )}

        {/* Rendered at the page root so it overlays the whole page, not the order panel */}
        {/* `ck-page` brings back the old page's tokens/scope that Checkout.css gives the modal;
            `display: contents` (see CheckoutPage.css) keeps that wrapper from adding any box. */}
        {loggedIn && this.state.showModal && detail && (
          <div className="ck-page co-modal-host">
            <BookingFeeBreakdownModal
              ticketPrice={detail.ticketPrice}
              bookingFee={bookingFee}
              karamaleFee={detail.bookingFeeAdmission}
              karamaleRate={detail.karamaleRate}
              gatewayFlatFee={detail.gatewayFlatFee}
              gatewayRate={detail.gatewayRate}
              estimatedGatewayFee={detail.estimatedGatewayFee}
              finalEstimatedGatewayFee={detail.finalEstimatedGatewayFee}
              onClose={() => this.setState({ showModal: false })}
            />
          </div>
        )}
      </div>
    )
  }
}

export default Finalize
